import api from "../utils/axios";

export const createSignRequest = async (formData) => {
  try {
    const response = await api.post("/signRequests/create", formData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSignRequests = async ({
  status,
  page = 1,
  limit = 10,
  sortBy,
  sortOrder,
  search,
}) => {
  try {
    const params = {
      status,
      page,
      limit,
      sortBy,
      sortOrder,
    };
    
    if (search) {
      params.search = search;
    }
    
    const response = await api.get("/signRequests", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getSignRequestById = async (id, userId) => {
  try {
    const response = await api.get(`/signRequests/details/${id}/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteSignRequest = async (id) => {
  try {
    const response = await api.delete(`/signRequests/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAuditLogs = async (signRequestId) => {
  try {
    const response = await api.get(
      `/signRequests/audit-trail/${signRequestId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const uploadRecipientAttachments = async (
  signRequestId,
  recipientContactId,
  formData
) => {
  try {
    const response = await api.post(
      `/signRequests/upload-recipient-attachments/${signRequestId}/${recipientContactId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllRecipientAttachments = async (signRequestId) => {
  try {
    const response = await api.get(
      `/signRequests/all-recipient-attachments/${signRequestId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const resendNotification = async (signRequestId) => {
  try {
    const response = await api.post(`/signRequests/resend-notification/${signRequestId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateRecipientEmail = async (
  signRequestId,
  recipientContactId,
  email
) => {
  try {
    const response = await api.put(
      `/signRequests/update-recipient-email/${signRequestId}/${recipientContactId}`,
      { newEmail: email }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const generateOTP = async (signRequestId, contactId) => {
  try {
    const response = await api.post(
      `/signRequests/generate-otp/${signRequestId}/${contactId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const verifyOTP = async (signRequestId, contactId, otp) => {
  try {
    const response = await api.post(
      `/signRequests/verify-otp/${signRequestId}/${contactId}`,
      { otp }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
